import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {

  constructor(
    private router: Router,
    private tokenService: TokenStorageService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.tokenService.getToken()) {
      return true;
    }
    this.router.navigate(['/login']);

    return false;
  }
}
